<template>
  <!-- 管线图层 -->
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24" v-if="this.$store.state.user.info.systemAdmin">
            <a-form-item label="水司">
              <a-select placeholder="请选择" default-value v-model="query.tenantId" allow-clear>
                <a-select-option v-for="item in tenantList" :key="item.tenantId" :value="item.tenantId">{{
                  item.tenantName
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="道路选择">
              <a-input v-model="query.road" placeholder="请输入道路选择" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="分类编号">
              <a-input v-model="query.classNo" placeholder="请输入开始、结束分类编号" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="物探点号">
              <a-input v-model="query.geophysicalPointNumber" placeholder="请输入物探点号" allow-clear />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="管材">
              <a-select placeholder="请选择管线材质" v-model="query.pipeMaterial" allow-clear>
                <a-select-option v-for="(item, index) in pipeLineMaterialOptions" :key="index" :value="item">{{ item }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="12">
            <a-form-item label="管径">
              <a-select placeholder="请选择管径大小" v-model="query.pipeDiameter" allow-clear>
                <a-select-option v-for="(item, index) in pipeDiameterSizeOptions" :key="index" :value="item">DN{{ item
                  }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="48">
          <!-- <a-col :md="6" :sm="12">-->
          <!--   <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="分区选择">-->
          <!--     <a-tree-select-->
          <!--       :tree-data="zoneTreeData"-->
          <!--       v-model="query.zoneId"-->
          <!--       style="width: 100%"-->
          <!--       :replace-fields="{ title: 'zoneName', key: 'id', value: 'id', selectable: 'selectable' }"-->
          <!--       :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"-->
          <!--       placeholder="请选择片区"-->
          <!--       allow-clear-->
          <!--       tree-default-expand-all-->
          <!--     ></a-tree-select>-->
          <!--   </a-form-item>-->
          <!-- </a-col>-->
          <a-col :md="8" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="addOrUpdateHandle()" v-action:add>新增</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="downloadTemplate({ excelForm: true })"
                v-action:upload>下载模板</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="exportHandleIdList()" :loading="exportLoading"
                v-action:export>导出</a-button>
              <a-button type="primary" style="margin-left: 8px" :loading="importLoading" @click="importHandle"
                v-action:import>
                <a-icon type="upload" />导入
              </a-button>
              <a-button type="primary" icon="hdd" style="margin-left: 8px" @click="recycleBinVisible = true"
                v-action:recycle>回收站</a-button>
              <a-button type="primary" icon="check" style="margin-left: 8px" @click="dataCheckVisible = true"
                v-action:check>检查</a-button>
              <a-button type="danger" style="margin-left: 8px" @click="deleteSelectRow()" v-action:del>删除</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="clear" v-action:clear>一键清空数据</a-button>

            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <a-table rowKey="id" bordered :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)" :data-source="list"
      :columns="columns" :loading="dataListLoading" :pagination="pagination" @change="pageChange">
      <span slot="action" slot-scope="text, record">
        <a @click="addOrUpdateHandle(record.id)" v-action:edit>编辑</a>
      </span>
      <span slot="createTime" slot-scope="text">{{ moment(text).format('YYYY-MM-DD') }}</span>
    </a-table>


    <a-modal title="操作" style="top: 20px" :width="800" v-model="addOrUpdateVisible" @ok="handleOk"
      @cancel="handleCancel">
      <a-form class="log-form" :form="addOrUpdateForm">
        <a-row class="form-row" :gutter="16">
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="起点编码">
              <a-input placeholder="起点编码"
                v-decorator="['startClassNo', { rules: [{ required: true, message: '起点编码' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="终点编码">
              <a-input placeholder="终点编码"
                v-decorator="['endClassNo', { rules: [{ required: true, message: '终点编码' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="物探点号">
              <a-input placeholder="物探点号" v-decorator="[
                'startGeophysicalPointNumber',
                { rules: [{ required: true, message: '请输入物探点号' }] },
              ]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="连接点号">
              <a-input placeholder="连接点号"
                v-decorator="['endGeophysicalPointNumber', { rules: [{ required: true, message: '请输入连接点号' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="特征点">
              <a-input placeholder="特征点"
                v-decorator="['featurePoint', { rules: [{ required: false, message: '请输入特征点' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="附属物">
              <a-input placeholder="附属物"
                v-decorator="['appendage', { rules: [{ required: false, message: '请输入附属物' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="附属物">
              <a-input placeholder="构筑物"
                v-decorator="['structure', { rules: [{ required: false, message: '请输入附属物' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="地面高程">
              <a-input placeholder="地面高程" v-decorator="[
                'elevation',
                { rules: [{ pattern: /^[0-9]+\.?[0-9]*$/, required: false, message: '请输入地面高程m' }] },
              ]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="埋深">
              <a-input placeholder="埋深" v-decorator="[
                'buriedDepth',
                { rules: [{ pattern: /^(\-|\+)?\d+(\.\d+)?$/, required: false, message: '请输入正确埋深' }] },
              ]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="管材">
              <a-input placeholder="管材"
                v-decorator="['pipeMaterial', { rules: [{ required: true, message: '请输入管材' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="管径">
              <a-input placeholder="管径" v-decorator="[
                'pipeDiameter',
                { rules: [{ pattern: /^[0-9]+\.?[0-9]*$/, required: false, message: '请输入管径' }] },
              ]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="长度">
              <a-input placeholder="长度" v-decorator="[
                'length',
                { rules: [{ pattern: /^[0-9]+\.?[0-9]*$/, required: true, message: '请输入长度' }] },
              ]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="压力等级">
              <a-select v-decorator="['voltageType', { rules: [{ required: true, message: '请选择压力等级!' }] }]"
                placeholder="选择压力等级" @change="handleSelectChange">
                <a-select-option value="市政压力"> 市政压力 </a-select-option>
                <a-select-option value="中压"> 中压 </a-select-option>
                <a-select-option value="高压"> 高压 </a-select-option>
              </a-select>
            </a-form-item>
            <!-- <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="压力等级">
              <a-input
                placeholder="压力等级"
                v-decorator="[
                  'voltageType',
                  { rules: [{ required: false, message: '请输入压力等级' }] },
                ]"
              />
            </a-form-item> -->
          </a-col>
          <!--          <a-col :lg="12" :md="12" :sm="24">-->
          <!--            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="片区选择">-->
          <!--              <a-tree-select-->
          <!--                :tree-data="zoneTreeData"-->
          <!--                v-decorator="['zoneId', { rules: [{ required: false, message: '请选择片区' }] }]"-->
          <!--                style="width: 100%"-->
          <!--                :replace-fields="{ title: 'zoneName', key: 'id', value: 'id', selectable: 'selectable' }"-->
          <!--                :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"-->
          <!--                placeholder="请选择片区"-->
          <!--                allow-clear-->
          <!--                tree-default-expand-all-->
          <!--              ></a-tree-select>-->
          <!--            </a-form-item>-->
          <!--          </a-col>-->
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="片区名称">
              <a-input placeholder="片区名称"
                v-decorator="['zoneName', { rules: [{ required: false, message: '请输入片区名称' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="道路选择">
              <a-input placeholder="道路选择"
                v-decorator="['road', { rules: [{ required: false, message: '请输入道路选择' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="原始文件名">
              <a-input placeholder="原始文件名"
                v-decorator="['originalFileName', { rules: [{ required: false, message: '请输入原始文件名' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="探测台组编号">
              <a-input placeholder="探测台组编号"
                v-decorator="['probeGroupNo', { rules: [{ required: false, message: '请输入探测台组编号' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="工程名称">
              <a-input placeholder="工程名称"
                v-decorator="['projectName', { rules: [{ required: false, message: '请输入工程名称' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="工程类别">
              <a-input placeholder="工程类别"
                v-decorator="['projectType', { rules: [{ required: false, message: '工程类别' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="工程编号">
              <a-input placeholder="工程编号"
                v-decorator="['projectNo', { rules: [{ required: false, message: '工程编号' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="施工单位">
              <a-input placeholder="施工单位"
                v-decorator="['constructionUnit', { rules: [{ required: false, message: '施工单位' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="工程管理人">
              <a-input placeholder="工程管理人"
                v-decorator="['projectManager', { rules: [{ required: false, message: '工程管理人' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="工程负责人">
              <a-input placeholder="工程负责人"
                v-decorator="['projectLeader', { rules: [{ required: false, message: '工程负责人' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="竣工时间">
              <a-input placeholder="竣工时间"
                v-decorator="['completionDate', { rules: [{ required: false, message: '竣工时间' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :lg="12" :md="12" :sm="24">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
              <a-input placeholder="备注" v-decorator="['remark', { rules: [{ required: false, message: '备注' }] }]" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <RecycleBinModal :visible.sync="recycleBinVisible" @ok="modalFormOk"></RecycleBinModal>
    <DataCheck :visible.sync="dataCheckVisible" @ok="modalFormOk"></DataCheck>
    <importModal ref="importModal" :tree-data="zoneTreeData" @reLoad="resetList"
      exportUrl="/pipe-network/gis/pipe-lines/import"></importModal>
    <a-modal v-model="mapVisible" title="图层展示" width="60%" :mask="false" @ok="mapVisible = false">
      <div style="height: 500px">
        <collection-map ref="map" :type="1" :geo="geoJson" />
      </div>
    </a-modal>
  </a-card>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import CollectionMap from '@/components/map/CollectionMap.vue'
import importModal from './module/ImportModalNotZone.vue'
import RecycleBinModal from './module/NewRecycleBinModal'
import DataCheck from './module/NewDataCheckModal'
import { listByGroupProperties } from '@/api/manage'
import { handleImportBlobResponse } from '@/utils/importUtils'
const columns = [
  {
    title: '所在道路',
    dataIndex: 'road',
    ellipsis: true
  },
  {
    title: '起点编码',
    dataIndex: 'startClassNo',
    width: '150px'
  },
  {
    title: '终点编码',
    dataIndex: 'endClassNo',
    width: '150px'
  },
  {
    title: '物探点',
    dataIndex: 'startGeophysicalPointNumber'
    // ellipsis: true
  },
  {
    title: '连接点',
    dataIndex: 'endGeophysicalPointNumber'
    // ellipsis: true
  },
  {
    title: '特征点',
    dataIndex: 'featurePoint'
  },
  {
    title: '附属物',
    dataIndex: 'appendage'
  },
  {
    title: '构筑物',
    dataIndex: 'structure'
  },
  {
    title: '高程',
    dataIndex: 'elevation',
    width: '100px'
  },
  {
    title: '埋深',
    dataIndex: 'buriedDepth'
  },
  {
    title: '管材',
    dataIndex: 'pipeMaterial'
  },
  {
    title: '管径',
    dataIndex: 'pipeDiameter'
  },
  {
    title: '长度(M)',
    dataIndex: 'length'
  },
  {
    title: '创建时间',
    width: '120px',
    dataIndex: 'createTime',
    scopedSlots: { customRender: 'createTime' }
  },
  {
    title: '操作',
    width: '80px',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' }
  }
]

export default {
  components: { CollectionMap, importModal, RecycleBinModal, DataCheck },
  mixins: [mixinViewModule],
  name: 'PipeLineLayer',
  data () {
    return {
      list: [],
      messages: '',
      mapVisible: false,
      currentId: '',
      queryUrl: '/pipe-network/gis/pipe-lines/page',
      deleteUrl: '/pipe-network/gis/pipe-lines',
      addOrUpdateUrl: '/pipe-network/gis/pipe-lines',
      queryOneUrl: '/pipe-network/gis/pipe-lines',
      queryZoneDateUrl: 'zone-metering/zone-metering',
      exportDataUrl: 'pipe-network/gis/pipe-lines/export',
      exportFileName: '管线数据.xlsx',
      downloadTemplateUrl: 'pipe-network/gis/pipe-lines/template/download',
      downloadTemplateName: '管线数据导入模板.xlsx',
      importLoading: false,
      recycleBinVisible: false, // 回收站操作
      dataCheckVisible: false, // 数据检查
      geoJson: '',
      pipeLineMaterialOptions: [], // 管线材质选项
      pipeDiameterSizeOptions: [], // 管径大小选项
      zoneTreeData: [], // 片区选项
      query: {
        road: '',
        classNo: '',
        geophysicalPointNumber: '',
        connection: '',
        zoneId: '',
        tenantId: this.$store.state.user.info.tenantId,
        pipeMaterial: '',
        pipeDiameter: ''
      },
      labelCol: { span: 8 },
      wrapperCol: { span: 14 },
      columns,
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' })
    }
  },

  created () {
    this.getAllTenant()
    this.listPipeDiameterSizeOptions()
    this.listPipeLineMaterialOptions()
    this.getZoneData()
    this.resetList()
  },
  methods: {
    resetList () {
      if (this.query.sysType) {
        const params = {
          sysType: this.query.sysType
        }
        this.query = params
      } else {
        this.query = {}
      }

      this.pagination.current = 1
      this.selectedRows = []
      this.queryList()

    },
    clear () {
      this.$confirm({
        title: '清空数据',
        content: `您确定要清空所有数据吗？`,
        centered: true,
        onOk: () => {
          this.$http.put('/pipe-network/gis/pipe-lines/empty/pipeline').then((res) => {
            if (res.code == 0) {
              this.$message.success('操作成功')
              this.queryList()
            }
          })
        }
      })
    },
    modalFormOk () {
      this.queryList()
    },
    importHandle () {
      this.$refs.importModal.show()
    },
    handleSelectChange (value) {
      this.addOrUpdateForm.setFieldsValue({
        voltageType: value
      })
    },
    saveFile (formData) {
      this.importLoading = true
      this.axios({
        method: 'post',
        url: '/pipe-network/gis/pipe-lines/import',
        headers: {},
        params: {},
        data: formData,
        responseType: 'blob'
      })
        .then((response) => handleImportBlobResponse(response, { errorFileName: '管线导入失败数据.xlsx' }))
        .then(({ hasErrorFile, message }) => {
          this.queryList()
          if (hasErrorFile) {
            this.$message.warning(message)
          } else {
            this.$message.success(message)
          }
        })
        .catch((error) => {
          this.$message.error(error.message || '导入失败')
        })
        .finally(() => {
          this.importLoading = false
        })
    },
    getZoneData () {
      this.$http.get(this.queryZoneDateUrl).then(({ data }) => {
        this.zoneTreeData = data
      })
    },
    listPipeLineMaterialOptions () {
      listByGroupProperties('pipe_material').then(({ data }) => {
        this.pipeLineMaterialOptions = data
      })
    },
    listPipeDiameterSizeOptions () {
      listByGroupProperties('pipe_diameter').then(({ data }) => {
        this.pipeDiameterSizeOptions = data
      })
    },
    detailInfo (record) {
      this.detailForm = { ...record }
    },
    showLineLayer (record) {
      this.geoJson = record.geoJson
      this.mapVisible = true
    },
    handleCancel () { }
  },
  watch: {}
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}

.log-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

/deep/.ant-table-thead>tr>th> {
  text-align: center;
}

/deep/.ant-table-tbody>tr>td {
  text-align: center;
}
</style>
